import HomeDashboard from "../../xpost/views/home/HomeDashboard.vue";
import ForgetPassword from '../../xpost/components/ForgetPassword.vue';
import Login from '../../xpost/components/Login.vue';
import Profile from '../../xpost/components/Profile.vue';
import Chat from '../../xpost/components/chat/Chat.vue';
import { TokenService } from '../../services/auth/storage.services.js';

const AdminRoutes = [
  {
    path: "/",
    name: "home",
    meta: {
      public: false,
    },
    components: {
      default: HomeDashboard,
    },
  },
  {
    path: "/perfil",
    name: "profile",
    meta: {
      public: false,
    },
    components: {
      default: Profile,
    },
  },
  {
    path: "/login",
    name: "login",
    meta: {
      public: true,
    },
    components: {
      default: Login,
    },
  }, {
    // ENTRAR: aba aberta pelo admin; o token vem no fragmento (#) para não chegar ao servidor
    // nem ao log do nginx. Fica só no sessionStorage desta aba e a página recarrega com ele.
    path: "/entrar-como",
    name: "impersonate",
    meta: {
      public: true,
    },
    components: {
      default: { render: () => null },
    },
    beforeEnter() {
      const token = window.location.hash.slice(1);
      if (token) {
        TokenService.startImpersonation(token);
      }
      window.location.replace("/");
    },
  }, {
    path: "/chat",
    name: "chat",
    meta: {
      public: false
    },
    components: {
      default: Chat
    }
  }, {
    path: "/forget",
    name: "forget",
    meta: {
      public: true,
    },
    components: {
      default: ForgetPassword,
    },
  },
  { path: "/home", redirect: { name: "home" } },
];

export default AdminRoutes;
